import { combineReducers } from 'redux';
import projects, * as projectSelectors from './projects';
import ui, * as uiSelectors from './ui';

const rootReducer = combineReducers({
  projects: projects,
  ui: ui,
});

export default rootReducer;

export const getAllProjects = state =>
  projectSelectors.getProjects(state.projects);
export const getProjectsByCluster = state =>
  projectSelectors.getProjectsByCluster(state.projects);
export const getProjectsByPriority = state =>
  projectSelectors.getProjectsByPriority(state.projects);
export const getBudgets = state => projectSelectors.getBudgets(state.projects);
export const getProjectsByBudget = state =>
  projectSelectors.getProjectsByBudget(state.projects);

export const getActiveProject = state => uiSelectors.getActiveProject(state.ui);
export const getActiveTab = state => uiSelectors.getActiveTab(state.ui);
export const getIsFetchingProjects = state =>
  uiSelectors.getIsFetchingProjects(state.ui);
export const tabChangeRequested = state =>
  uiSelectors.tabChangeRequested(state.ui);
export const tabChangeReady = state => uiSelectors.tabChangeReady(state.ui);
export const getRequestedTab = state => uiSelectors.getRequestedTab(state.ui);



// WEBPACK FOOTER //
// ./src/reducers/index.js